module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.12/_next/static/images/post-contato-serasa-5f3c6e155460633b940961a8b449d4ab.webp";